import { useFields } from "../../../../api/useFields";
import { findField } from "../../../../utils/findField";
import { getChipLabel } from "../../../../components/chips/CustomChip";
import { MultiSelectFilter } from "../../../../components/general-filters/MultiSelectFilter";

type LogbookStatusFilterProps = {
	sessions: Array<any>;
	selectedStatuses: Array<string>;
	onChange: (statuses: Array<string>) => void;
};

export const LogbookStatusFilter = ({ sessions, selectedStatuses, onChange }: LogbookStatusFilterProps) => {
	const { formatedFields } = useFields("sessions");
	const statusField = findField(formatedFields, "status");

	const uniqueStatuses = new Set(
		sessions.map((s: any) => s.status).filter(Boolean)
	);

	const fieldChoices = statusField?.settings?.options?.choices ?? [];
	const options = fieldChoices
		.filter((choice: any) => uniqueStatuses.has(choice.value))
		.map((choice: any) => ({
			value: choice.value,
			label: getChipLabel(statusField!, choice.value) ?? choice.value,
		}));

	return (
		<MultiSelectFilter
			label="Sessão Estado"
			options={options}
			selected={selectedStatuses}
			onChange={onChange}
		/>
	);
};
